import { createSlice } from "@reduxjs/toolkit";

import { IntercomConversationType, LocalMonitoringSliceStateType } from "shared/types";
import { LevelType } from "shared/types/monitoring_event";
import { MONITORING_EVENT_TYPES } from "shared/utils/monitoring";

const initialState: LocalMonitoringSliceStateType = {
  intercom: {},
  monitoring_event_table_events_per_page: 250,
  monitoring_event_table_levels: [LevelType.IMPORTANT as string],
  monitoring_event_table_types: [...Object.keys(MONITORING_EVENT_TYPES), "all"],
  monitoring_event_table_users: [],
  start_time_filter: "",
  end_time_filter: "",
};

const localMonitoringSlice = createSlice({
  name: "local_monitoring",
  initialState,
  reducers: {
    setIntercomConversations: (state, action: { payload: IntercomConversationType[] }) => {
      const newState: { [id: string]: IntercomConversationType } = {};
      for (const { id, klass_id, user_id, ...rest } of action.payload) {
        newState[`${id}`] = {
          id: `${id}`,
          klass_id: `${klass_id}`,
          user_id: `${user_id}`,
          ...rest,
        };
      }
      state.intercom = newState;
    },
    setMonitoringEventTableEventsPerPage: (state, action) => {
      state.monitoring_event_table_events_per_page = action.payload;
    },
    setMonitoringEventTableLevels: (state, action) => {
      state.monitoring_event_table_levels = action.payload;
    },
    setMonitoringEventTableTypes: (state, action) => {
      state.monitoring_event_table_types = action.payload;
    },
    setMonitoringEventTableUsers: (state, action) => {
      state.monitoring_event_table_users = action.payload;
    },
    setStartTimeFilter: (state, action) => {
      state.start_time_filter = action.payload;
    },
    setEndTimeFilter: (state, action) => {
      state.end_time_filter = action.payload;
    },
    setTimeFilter: (state, action) => {
      state.start_time_filter = action.payload.startTimeFilter;
      state.end_time_filter = action.payload.endTimeFilter;
    },
  },
});

export const {
  setIntercomConversations,
  setMonitoringEventTableEventsPerPage,
  setMonitoringEventTableLevels,
  setMonitoringEventTableTypes,
  setMonitoringEventTableUsers,
  setStartTimeFilter,
  setEndTimeFilter,
  setTimeFilter,
} = localMonitoringSlice.actions;

export const localMonitoringSliceReducer = localMonitoringSlice.reducer;
